import categories from './categories';
import fields from './fields';

export default {
  /**
   * Set up the Algolia credentials
   */
  algolia_app_id: '8VOK4WOPYE',
  algolia_api_key: 'a32630f310e8bde72e07a235bdadda86',
  algolia_index: 'BERG-LAW',

  /**
   * Set up Analytics info for tracking survey responses
   */
  analytics_id: 'UA-130768066-3',

  /**
   * Set up the Google Sheet information so it can make requests to the right place
   */
  google_sheet_title: 'BERG-Law-2019-DB',

  /**
   * The expiration date of the survey, where no more submissions will be accepted
   * Format: 'July 3, 2018'
   */
  expiration_date: 'May 9, 2019',

  /**
   * Set some variables for the display of the survey
   */
  survey_title: 'Bergen Top Lawyers - 2019',
  survey_subtitle: 'Professional Law Awards',
  social_title: 'Cast your vote for the Top Lawyer in the Bergen area!',
  publication_logo: null,
  welcome_title: 'Welcome!',
  welcome: 'Welcome to the Bergen Top Lawyers ballot, brought to you by Bergen magazine.<br><br><span class="has-text-danger">The deadline for all nominations is May 8th, 2019.</span>',
  rules: [
    'If you vote for  yourself, you must vote for at least two candidates outside your practice in the same category.',
    'You may only submit one ballot per year.',
    'You must have a current AND active license (bar number).',
  ],
  categories,
  fields,
  votes_per_category: 3,
  write_in_limit: 10,
  vote_requirement: 1,

  /**
   * Set some defaults for values that get manipulated while the survey is being filled out
   */
  vote_count: 0,
  submission: new FormData(),
};
